(()=>{
  function init(root){
    if(root.dataset.ready)return;
    root.dataset.ready='1';
    if(!root.querySelector('.pp-form'))return;

    const data=JSON.parse(root.querySelector('[data-pp-data]').textContent);
    const form=root.querySelector('.pp-form');
    const radios=[...form.querySelectorAll('[name=bundle]')];
    const btn=form.querySelector('[data-pp-add]');
    const status=root.querySelector('[data-pp-status]');
    const main=root.querySelector('[data-pp-main]');
    const money=n=>new Intl.NumberFormat('en-US',{style:'currency',currency:data.currency}).format(n/100);
    let chosen=0;
    let isSubmitting=false;

    function update(){
      const offer=data.offers[chosen];
      root.querySelectorAll('[data-pp-price]').forEach(el=>el.textContent=offer?money(offer.price):'Unavailable');
      root.querySelector('[data-pp-currency]').textContent=data.currency;
      form.querySelector('[data-pp-id]').value=offer?.id||'';
      btn.disabled=!offer||!offer.available||isSubmitting;
      btn.querySelector('span').textContent=isSubmitting?'Updating Bag…':offer?.available?'Add to Bag':'Unavailable';
      status.textContent='';
      if(offer?.image){
        main.src=offer.image;
        main.alt=(chosen+1)+' Grace in Bloom bracelet'+(chosen?'s':'');
      }
    }

    radios.forEach((r,i)=>{
      const offer=data.offers[i];
      r.disabled=!offer||!offer.available;
      const label=root.querySelector('[data-price-label="'+i+'"]');
      label.replaceChildren();
      label.append(document.createTextNode(offer?money(offer.price):'Unavailable'));
      const small=document.createElement('small');
      const savings=offer&&data.offers[0]?data.offers[0].price*(i+1)-offer.price:0;
      small.textContent=savings>0?'Save '+money(savings)+' vs. singles':i===0?'Single bracelet':'Set total';
      label.append(small);
      r.addEventListener('change',()=>{chosen=i;update();});
    });

    const first=radios.findIndex(r=>!r.disabled);
    if(first>=0){chosen=first;radios[first].checked=true;}
    update();

    root.querySelectorAll('[data-photo]').forEach(b=>b.addEventListener('click',()=>{
      main.src=b.dataset.photo;
      main.alt=b.dataset.alt;
    }));

    root.querySelectorAll('[data-pp-select]').forEach(b=>b.addEventListener('click',()=>{
      const i=Number(b.dataset.ppSelect);
      if(Number.isInteger(i)&&radios[i]&&!radios[i].disabled){
        chosen=i;
        radios[i].checked=true;
        update();
        form.scrollIntoView({behavior:'smooth',block:'center'});
      }
    }));

    form.addEventListener('submit',async e=>{
      // IMPORTANT: only intercept our Add to Bag button.
      // Shopify's accelerated checkout buttons must keep their native flow.
      const submitter=e.submitter;
      if(submitter && !submitter.matches('[data-pp-add]')){
        return;
      }

      if(data.preview){
        e.preventDefault();
        status.textContent='Preview only — your '+(chosen+1)+'-bracelet set is '+money(data.offers[chosen].price)+'. Checkout will use your Shopify product.';
        return;
      }

      const offer=data.offers[chosen];
      if(!offer?.available){
        e.preventDefault();
        status.textContent='Please choose an available set.';
        return;
      }

      if(isSubmitting){
        e.preventDefault();
        return;
      }

      e.preventDefault();
      isSubmitting=true;
      update();
      status.textContent='Preparing your selected set…';

      try{
        const clearResponse=await fetch('/cart/clear.js',{
          method:'POST',
          headers:{'Accept':'application/json'}
        });
        if(!clearResponse.ok)throw new Error('Unable to reset bag');

        const addResponse=await fetch('/cart/add.js',{
          method:'POST',
          headers:{
            'Accept':'application/json',
            'Content-Type':'application/json'
          },
          body:JSON.stringify({
            items:[{id:Number(offer.id),quantity:1}]
          })
        });
        if(!addResponse.ok)throw new Error('Unable to add item');

        // Publish a custom Shopify customer event only after the cart add succeeds.
        // The Custom Pixel subscribes to this as a reliable AddToCart fallback.
        if(window.Shopify && Shopify.analytics && typeof Shopify.analytics.publish==='function'){
          const variantName=(chosen+1)+' Bracelet'+(chosen===0?'':'s');
          try{
            await Shopify.analytics.publish('petal_pebble:add_to_cart',{
              variant_id:String(offer.id),
              product_name:'Grace in Bloom',
              variant_name:variantName,
              quantity:1,
              value:Number(offer.price||0)/100,
              currency:data.currency||'USD',
              content_ids:[String(offer.id)],
              contents:[{id:String(offer.id),quantity:1}]
            });
          }catch(_err){}
        }

        window.location.assign('/cart');
      }catch(err){
        isSubmitting=false;
        update();
        status.textContent='We couldn’t update your bag. Please try again.';
      }
    });
  }

  document.querySelectorAll('[data-pp-root]').forEach(init);
  document.addEventListener('shopify:section:load',e=>e.target.querySelectorAll('[data-pp-root]').forEach(init));
})();
